// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as ReactModal from "react-modal";
import * as NextRecaptchaV3 from "next-recaptcha-v3";
import * as Config$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/configs/Config.mjs";
import * as LeadFlowVm$PorterinFeature from "../../../lead-flow/view/view-model/LeadFlowVm.mjs";
import * as SharedHelper$PorterinFeature from "../../../core/helpers/SharedHelper.mjs";
import * as RecaptchaProvider$PorterinFeature from "../../../../contexts/recpatcha-context/RecaptchaProvider.mjs";
import * as VehicleModalLayoutCmp$PorterinFeature from "../../../vehicles/view/components/VehicleModalLayoutCmp.mjs";
import * as FareEstimateModalModuleScss from "../styles/FareEstimateModal.module.scss";
import * as VehicleFareEstimateFormCmp$PorterinFeature from "../../../lead-flow/view/VehicleFareEstimateFormCmp.mjs";
import * as VehicleFareEstimateFormModalModuleScss from "../styles/VehicleFareEstimateFormModal.module.scss";
import * as VehicleFareEstimateInputModalModuleScss from "../styles/VehicleFareEstimateInputModal.module.scss";

var modal_form_styles = VehicleFareEstimateFormModalModuleScss;

var input_field_styles = VehicleFareEstimateInputModalModuleScss;

var styles = FareEstimateModalModuleScss;

function VehicleFareEstimateModalCmp(Props) {
  var modal = Props.modal;
  var service_category = Props.service_category;
  var vehicle = Props.vehicle;
  var fare_estimate_form_content = Props.fare_estimate_form_content;
  var match = React.useState(function () {
        return false;
      });
  var setRecaptchaState = match[1];
  var isRecaptchaFailed = match[0];
  var fare_estimate_vm = LeadFlowVm$PorterinFeature.getLeadFlowVm(fare_estimate_form_content.fare_estimate_content);
  React.useEffect((function () {
          return SharedHelper$PorterinFeature.reloadAfterRecaptchaFailure(isRecaptchaFailed);
        }), [isRecaptchaFailed]);
  return React.createElement(ReactModal, {
              isOpen: modal.modal_state,
              onRequestClose: modal.close_modal,
              closeTimeoutMS: 0,
              overlayClassName: styles.overlay,
              className: styles["modal-container"],
              ariaHideApp: false,
              shouldCloseOnOverlayClick: true,
              children: React.createElement(NextRecaptchaV3.ReCaptchaProvider, {
                    reCaptchaKey: Config$PorterinUtils.recaptcha_site_key,
                    useEnterprise: true,
                    children: React.createElement(RecaptchaProvider$PorterinFeature.make, {
                          value: {
                            isRecaptchaFailed: isRecaptchaFailed,
                            setRecaptchaState: (function (flag) {
                                Curry._1(setRecaptchaState, (function (param) {
                                        return flag;
                                      }));
                              })
                          },
                          children: React.createElement(VehicleModalLayoutCmp$PorterinFeature.make, {
                                children: React.createElement(VehicleFareEstimateFormCmp$PorterinFeature.make, {
                                      service_category: service_category,
                                      styles: modal_form_styles,
                                      input_field_styles: input_field_styles,
                                      fare_estimate_vm: fare_estimate_vm,
                                      source: Belt_Option.isNone(vehicle) ? /* MobileSticky */2 : /* KnowMore */0,
                                      on_lead_success_handler: (function (param) {
                                          
                                        })
                                    }),
                                modal: modal,
                                vehicle: vehicle,
                                modal_content: fare_estimate_vm.mobile_modal_content
                              })
                        })
                  })
            });
}

var make = VehicleFareEstimateModalCmp;

export {
  modal_form_styles ,
  input_field_styles ,
  styles ,
  make ,
}
/* modal_form_styles Not a pure module */
